import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { usePrefs } from "@/lib/context";
import { ReceiptView } from "@/components/Schedule";

export default function PaymentResult({ cancelled }) {
  const [params] = useSearchParams();
  const { t } = usePrefs();
  const sid = params.get("session_id");
  const [state, setState] = useState(cancelled ? "cancel" : "pending");
  const [inst, setInst] = useState(null);
  useEffect(() => {
    if (cancelled || !sid) return;
    let n = 0, timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") {
          setInst((await api.get(`/payments/receipt/${sid}`)).data);
          return setState("paid");
        }
        if (data.payment_status === "expired") return setState("cancel");
      } catch { /* retry */ }
      if (++n < 15) timer = setTimeout(poll, 2000); else setState("timeout");
    };
    poll();
    return () => clearTimeout(timer);
  }, [sid, cancelled]);
  return (
    <div className="mx-auto max-w-md rise rounded-sm border border-slate-200 bg-white p-8" data-testid="payment-result">
      {state === "pending" && <div className="flex items-center gap-3 text-slate-600"><Loader2 className="animate-spin" />{t("paymentPending")}</div>}
      {state === "paid" && (
        <>
          <div className="mb-6 flex items-center gap-3 text-emerald-700" data-testid="payment-success"><CheckCircle2 /><span className="font-display text-2xl font-bold">{t("paymentSuccess")}</span></div>
          {inst && <ReceiptView inst={inst} />}
        </>
      )}
      {state === "timeout" && <div className="flex items-center gap-3 text-amber-700" data-testid="payment-timeout"><Loader2 /><span className="text-sm">Paiement en cours de traitement. Vérifiez votre échéancier dans quelques minutes.</span></div>}
      {state === "cancel" && <div className="flex items-center gap-3 text-rose-700" data-testid="payment-cancelled"><XCircle /><span className="font-display text-xl font-bold">{t("paymentCancel")}</span></div>}
      <Link to={inst?.kind === "invoice" ? "/finance" : "/leases"} className="mt-8 inline-block text-sm font-semibold text-[#996515] hover:underline" data-testid="payment-back-link">← {t("back")}</Link>
    </div>
  );
}
